import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import handleKeyPress from '../../common/handleKeyPress';
import * as Styled from './styles';

const VersionHistoryItem = ({
    dateSaved,
    firstName,
    lastName,
    email,
    isSelected,
    isParentCollapsed,
    isLatestSaved,
    selectVersionHistoryItem,
}) => {
    const [isMouseOver, setisMouseOver] = useState(false);

    const nameMessage = `Saved by ${firstName} ${
        lastName.length <= 6 || lastName === 'Support' ? lastName : lastName[0]
    }`;
    const momentDateSaved = moment.unix(dateSaved);

    // Using calendar() we get the locale timezone adjusted, we don't need to deal with this
    let dateSavedVerbiage = momentDateSaved.calendar(); // Today at 10:52 AM

    // Check if calendar() returned something different than Today or Yesterday e.g. Last Thursday or 01/02/2020
    if (dateSavedVerbiage.indexOf('Today') === -1 && dateSavedVerbiage.indexOf('Yesterday') === -1) {
        dateSavedVerbiage = `${momentDateSaved.format('D MMM YYYY')} at ${momentDateSaved.format('h:mm A')}`;
    }

    return (
        <Styled.VersionHistoryItemListItem
            isSelected={isSelected}
            isMouseOver={isMouseOver}
            onMouseEnter={() => setisMouseOver(true)}
            onMouseLeave={() => setisMouseOver(false)}
            onFocus={() => setisMouseOver(true)}
            onBlur={() => setisMouseOver(false)}
            onClick={() => selectVersionHistoryItem()}
            onKeyDown={(e) => handleKeyPress(e, selectVersionHistoryItem, true)}
            role="button"
            tabIndex={isParentCollapsed ? '-1' : '0'}
            aria-label="Select version"
        >
            {isLatestSaved && <Styled.VersionHistoryItemBoldText>Last saved version</Styled.VersionHistoryItemBoldText>}
            <Styled.VersionHistoryItemText>{dateSavedVerbiage}</Styled.VersionHistoryItemText>
            <Styled.VersionHistoryItemFadedText>{isMouseOver ? email : nameMessage}</Styled.VersionHistoryItemFadedText>
        </Styled.VersionHistoryItemListItem>
    );
};

VersionHistoryItem.propTypes = {
    dateSaved: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    isParentCollapsed: PropTypes.bool.isRequired,
    isLatestSaved: PropTypes.bool.isRequired,
    selectVersionHistoryItem: PropTypes.func.isRequired,
};

export default VersionHistoryItem;
